import { colorConstants } from 'config/colorConstants';
import _ from 'lodash';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';

interface Props {
    data: tileDataProp[];
    activeKey: string | number;
    style?: React.CSSProperties;
    onClick: any;
    disabled?: boolean;
}

export type tileDataProp = {
    label: string;
    dataKey?: string;
    key: string | number;
    tooltip?: string;
};

const activeColor = colorConstants.violet;
const inActiveColor = colorConstants.darkGrey;
const inActiveBackground = colorConstants.grey;

//TILE SWITCH COMPONENT
const TileButton: FC<Props> = ({ data, activeKey, style = {}, onClick, disabled = false }) => {
    const [disabledStyle, setDisabledStyle] = useState<any>({});

    const renderDisabledStyle = (disabled: boolean) => {
        setDisabledStyle({
            opacity: disabled ? '0.5' : 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
        });
    };
    //using a debounced function here to debounce the disabled prop which changes quickly when fetching value from apollo cache.
    const debouncedRenderDisabledStyle = useCallback(_.debounce(renderDisabledStyle, 300), []);

    useEffect(() => {
        debouncedRenderDisabledStyle(disabled);
    }, [disabled]);

    return (
        <div className="flex p-[2px] items-center rounded" style={{ background: inActiveBackground, ...style }}>
            {data.map((item) => {
                const isActive = activeKey === item.key;
                const style = {
                    border: isActive ? `1px solid ${activeColor}` : 'none',
                    background: isActive ? 'white' : inActiveBackground,
                    color: isActive ? activeColor : inActiveColor,
                    fontWeight: isActive ? 700 : 400,
                    textWrap: 'nowrap',
                    ...disabledStyle,
                };
                return (
                    <div
                        title={item?.tooltip}
                        onClick={() => {
                            if (disabled) return;
                            onClick(item);
                        }}
                        style={style}
                        className="px-3.5 flex items-center rounded font-xs"
                        key={item.key}
                    >
                        {item.label}
                    </div>
                );
            })}
        </div>
    );
};

export default TileButton;
